module.exports = __webpack_public_path__ + "img/SetupConnectivity1.204ce917.png";